import { ActionsUnion, createAction } from '@housinganywhere/safe-redux';
import { Thunk } from 'ha/myredux/types';
import { send as sendAlert } from 'ha/modules/Alertbar/actions';
import reportError from 'ha/helpers/bugsnag/reportError';
import { defineKey as T } from 'ha/i18n';
import { GlobalState } from 'ha/types/store';

import { isLoading } from '../selectors';

const ERROR_MESSAGE = T(
  'There was an error adding your favorite listing. Please try again later',
);

export const enum ActionTypes {
  ADD_TO_PENDING_LIST = '[favorites] ADD_TO_PENDING_LIST',
  START = '[favorites] ADD_FAVORITE',
  DONE = '[favorites] ADD_FAVORITE_DONE',
  FAIL = '[favorites] ADD_FAVORITE_FAIL',
}

export const Actions = {
  addToPendingList: (listingId: number) =>
    createAction(ActionTypes.ADD_TO_PENDING_LIST, listingId),
  start: (listingId: number) => createAction(ActionTypes.START, listingId),
  done: (listingId: number) => createAction(ActionTypes.DONE, listingId),
  fail: (listingId: number) => createAction(ActionTypes.FAIL, listingId),
};
export type Actions = ActionsUnion<typeof Actions>;

type AddFavoriteListing = (listingId: number) => Thunk<GlobalState>;

const addFavoriteListing: AddFavoriteListing = listingId => (
  dispatch,
  getState,
  { apiV2 },
) => {
  if (isLoading(getState(), listingId)) {
    return Promise.resolve();
  }

  dispatch(Actions.start(listingId));

  return apiV2
    .addFavoriteListing(listingId)
    .then(() => {
      dispatch(Actions.done(listingId));
    })
    .catch(error => {
      reportError(error);
      dispatch(
        sendAlert({
          text: ERROR_MESSAGE,
          kind: 'danger',
          dismissAfter: 5000,
        }),
      );
      dispatch(Actions.fail(listingId));
    });
};

export default addFavoriteListing;
